import { useQuery } from '@tanstack/react-query';
import * as api from './api';
import type { ListForecastRunsParams } from './schema';

const ROOT_KEY = 'forecastRuns';
const listKey = (params: ListForecastRunsParams) =>
  [ROOT_KEY, 'list', params] as const;
const detailKey = (id: string) => [ROOT_KEY, 'detail', id] as const;

export function useForecastRuns(params: ListForecastRunsParams) {
  return useQuery({
    queryKey: listKey(params),
    queryFn: () => api.listForecastRuns(params),
    placeholderData: (prev) => prev,
  });
}

export function useForecastRun(id: string | null) {
  return useQuery({
    queryKey: detailKey(id ?? ''),
    queryFn: () => api.getForecastRun(id as string),
    enabled: !!id,
  });
}
